const VERIFIER_BYTES = 32
const STATE_BYTES = 16

function base64url(bytes: Uint8Array): string {
  let binary = ''
  for (const byte of bytes) binary += String.fromCharCode(byte)
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function randomBase64url(byteLength: number): string {
  return base64url(crypto.getRandomValues(new Uint8Array(byteLength)))
}

export interface PkcePair {
  readonly verifier: string
  readonly challenge: string
  readonly method: 'S256'
}

/** RFC 7636. The verifier never leaves the device until it is exchanged, and only once. */
export async function createPkcePair(): Promise<PkcePair> {
  const verifier = randomBase64url(VERIFIER_BYTES)
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
  return { verifier, challenge: base64url(new Uint8Array(digest)), method: 'S256' }
}

/** Opaque, single-use, and compared on the way back: this is what stops a forged callback. */
export function createState(): string {
  return randomBase64url(STATE_BYTES)
}
